import React from 'react';
import { useState, useCallback } from 'react';
import Stack from '@mui/material/Stack';
import Accordion from '@mui/material/Accordion';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid2';
import Typography from '@mui/material/Typography';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary, { accordionSummaryClasses } from '@mui/material/AccordionSummary';
import { useResponsive } from 'src/hooks/use-responsive';
import Iconify from 'src/components/iconify';

// ----------------------------------------------------------------------

export const _faqs = [
  {
    question: "How do we ensure trainer quality and safety?",
    answer: "Every trainer on our platform undergoes a verification process, including:<br/>1. Certification verification.<br/>2. Background checks.<br/>3. Regular performance reviews based on feedback.",
  },
  {
    question: "How are your payments protected?",
    answer: "We use bank-level encryption and secure payment processing. Funds are only released to trainers after your session is completed and you're satisfied.",
  },
  {
    question: "Can I switch trainers if I'm not satisfied?",
    answer: "Absolutely! You can switch trainers at any time with no questions asked. Your unused credit remain valid, and we'll help you find a better match. There are no loyalty contracts or commitment requirements.",
  },
  {
    question: "Any limitation on switch trainers?",
    answer: "There is no limitation at all. Switch trainer whenever you want without any reason and no cost.",
  },
  {
    question: "What if I need to cancel or reschedule?",
    answer: "Managing your schedule is simple through our mobile app: <br/>1. Easily reschedule sessions with a few clicks.<br/>2. Cancel with 12+ hours notice for a full refund.<br/>3. Your trainer will be informed automatically.",
  },
  {
    question: "Are there any hidden fees?",
    answer: "Never. Our pricing is completely transparent:<br/>1. No registration fees.<br/>2. No cancellation fees (with 12+ hours notice).<br/>3. Clear, upfront session pricing.",
  },
];

// ----------------------------------------------------------------------

export default function MarketingLandingFaqs() {
  const mdUp = useResponsive('up', 'md');

  const [expanded, setExpanded] = useState(false);

  const handleChangeExpanded = useCallback(
    (panel) => (event, isExpanded) => {
      setExpanded(isExpanded ? panel : false);
    },
    []
  );

  return (
    <Container
      sx={{
        pt: { xs: 5, md: 10 },
        pb: { xs: 10, md: 15 },
      }}
    >
      <Grid container spacing={3} justifyContent="space-between" alignItems="center">
        <Grid size={{xs: 12, md: 12, lg: 12}}>
          <Typography variant="h2" sx={{
            mb: { xs: 8, md: 10 },
            textAlign: 'center',
            my: 3,
          }}>
            Frequently Asked Questions
          </Typography>

          {_faqs.map((faq, index) => (
            <Accordion
              key={index}
              expanded={expanded === faq.question}
              onChange={handleChangeExpanded(faq.question)}
            >
              <AccordionSummary
                sx={{
                  minHeight: 64,
                  [`& .${accordionSummaryClasses.content}`]: {
                    p: 0,
                    m: 0,
                  },
                  [`&.${accordionSummaryClasses.expanded}`]: {
                    bgcolor: 'action.selected',
                  },
                }}
              >
                <Typography variant="h6" sx={{ flexGrow: 1 }}>
                  {faq.question}
                </Typography>

                <Iconify
                  width={24}
                  icon={expanded === faq.question ? 'carbon:subtract' : 'carbon:add'}
                />
              </AccordionSummary>

              <AccordionDetails>
                <Typography
                  variant="body2"
                  dangerouslySetInnerHTML={{ __html: faq.answer }}
                />
              </AccordionDetails>
            </Accordion>
          ))}
        </Grid>
      </Grid>
    </Container>
  );
}
